import {ProductComponent} from '../../types';

export const filterByCode = (productComponents: ProductComponent[], code: string): ProductComponent[] => {
    return productComponents.filter((productComponent) => productComponent.code.toLowerCase().includes(code.toLowerCase()));
}